import { useContext } from "react";
import LoggedInUserContext from "./logged-in-user-context";

const useLoggedInUser = () => useContext(LoggedInUserContext);

export default useLoggedInUser;
